import { supportUserTicket } from "@/utils/constants";
import { handleResponse, handleError } from "@/utils/functions";

export default (axios) => ({
  getSupportOptions(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(supportUserTicket.options, { params: params })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getSupportList(params) {
    return new Promise((resolve, reject) => {
      axios
        .get(supportUserTicket.base, { params: params })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getTicketView(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${supportUserTicket.base}${id}/view/`)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getSupportStatistics() {
    return new Promise((resolve, reject) => {
      axios
        .get(`${supportUserTicket.base}support_statistics/`)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  // getSupportObject(id) {
  //   return new Promise((resolve, reject) => {
  //     axios
  //       .get(`${supportUserTicket.base}${id}/`)
  //       .then((res) => {
  //         resolve(handleResponse(res));
  //       })
  //       .catch((err) => {
  //         reject(handleError(err));
  //       });
  //   });
  // },
  createTicket(data) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${supportUserTicket.base}`, data)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },

  updateAcknowledge(payload) {
    return new Promise((resolve, reject) => {
      axios
        .patch(
          `${supportUserTicket.base}${payload.id}/acknowledge/`,
          payload.data
        )
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  updateInvalidTicket(payload) {
    return new Promise((resolve, reject) => {
      axios
        .patch(`${supportUserTicket.base}${payload.id}/invalid/`, payload.data)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  updateTicketStatus(payload) {
    return new Promise((resolve, reject) => {
      axios
        .patch(
          `${supportUserTicket.base}${payload.id}/changed_status/`,
          payload.data
        )
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  updateResolutionDateTicket(payload) {
    return new Promise((resolve, reject) => {
      axios
        .patch(
          `${supportUserTicket.base}${payload.id}/set_resolution_date/`,
          payload.data
        )
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  // updateSupport(payload) {
  //   return new Promise((resolve, reject) => {
  //     axios
  //       .put(`${supportUserTicket.base}${payload.id}/`, payload.data)
  //       .then((res) => {
  //         resolve(handleResponse(res));
  //       })
  //       .catch((err) => {
  //         reject(handleError(err));
  //       });
  //   });
  // },
  AddTicketAttachment(data) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${supportUserTicket.document}`, data)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
});
